import React, { Component } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from 'config';

class DisableInspect extends Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {
        // 🚫 Disable Right Click
        document.addEventListener("contextmenu", (event) => event.preventDefault());
        document.addEventListener("keydown", (event) => {
            if (
                event.key === "F12" || // Block F12
                (event.ctrlKey && event.shiftKey && event.code === "KeyI") || // Block Ctrl + Shift + I
                (event.ctrlKey && event.shiftKey && event.code === "KeyJ") || // Block Ctrl + Shift + J
                (event.ctrlKey && event.shiftKey && event.code === "KeyC") || // Block Ctrl + Shift + I
                (event.ctrlKey && event.shiftKey && event.code === "KeyK") || // Block Ctrl + Shift + J
                (event.ctrlKey && event.key === "U" || event.ctrlKey && event.key === "u") // Block Ctrl + U
            ) {
                event.preventDefault();
                event.stopPropagation();

                return false;
            }
        }, true);
    }

    componentWillUnmount() {
        document.removeEventListener("contextmenu", (event) => event.preventDefault());
        document.removeEventListener("keydown", (event) => event.preventDefault());
    }






    render() {
        return null;
    }
}

export default DisableInspect;